import { render, staticRenderFns } from "./TxRecord.vue?vue&type=template&id=5e14d32b&scoped=true"
import script from "./TxRecord.vue?vue&type=script&lang=js"
export * from "./TxRecord.vue?vue&type=script&lang=js"
import style0 from "./TxRecord.vue?vue&type=style&index=0&id=5e14d32b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e14d32b",
  null
  
)

export default component.exports